<template>
  <div id="sign_area">
    <template v-if="getHasPayment === 'credit'">
      <div class="message_area">
        <div class="message_area_btn"><el-button type="primary" @click="displayTermsPdf()">規約表示</el-button></div>
        ・ 私は、会員規約の一切の約款について、確認し、承諾しました。<br />
        ・ 私は、個人情報の取扱いに関する同意条項の内容について、確認し、同意しました。<br />
        ・
        私は、貴社による審査の結果入会が認められた場合には、加盟店が私の代わりに当該審査結果を受領することを委託します。<br />
        ・ 私は、カード番号を受領した場合は、善良なる管理者の注意義務をもって仕様及び保管するものとします。<br />
        ・ お申込いただいたクレジットカードは、当該加盟店利用専用のハウスカード仕様です。<br />
        ・ 私は、役務提供契約等のクーリングオフ及び中途解約の内容について、説明を受け、確認し、承諾しました。
      </div>
      <div class="checkarea">
        <el-checkbox v-model="check" border
          >私は、会員規約及び以上の内容を同意のうえ承諾し、貴社のクレジットカードを申し込みます。</el-checkbox
        >
      </div>
    </template>
    <template v-if="getHasPayment === 'installment'">
      <div class="message_area">
        <div class="message_area_btn"><el-button type="primary" @click="displayTermsPdf()">規約表示</el-button></div>
        ・私は、自社割賦兼保証委託申込の一切の約款について、確認し、承諾しました。<br />
        ・私は、販売店及び貴社の個人情報の取扱いに関する同意条項の内容について確認し、同意しました。<br />
        ・私は、役務提供契約等のクーリングオフ及び中途解約の内容について、説明を受け、確認し、承諾しました。
      </div>
      <div class="checkarea">
        <el-checkbox v-model="check" border
          >私は、上記の内容を同意のうえ承諾し、自社割賦兼保証委託申込をします。</el-checkbox
        >
      </div>
    </template>

    <ErrorMessage class="error-step5-required text-center"></ErrorMessage>
    <ErrorMessage class="error-id-exists text-center"></ErrorMessage>

    <div class="box-card-wrapper">
      <el-card class="box-card" v-show="check">
        <div slot="header" class="clearfix">
          <span><i class="fas fa-pencil-alt"></i> 枠内に身分証と同一の署名をしてください</span>
        </div>
        <div class="body">
          <div class="sign_space">
            <canvas class="canvas" id="sign_canvas" data-canvas="canvasData"></canvas>
          </div>
          <div class="clear_btn">
            <el-button icon="fas fa-eraser" round @click="eraser">書き直す</el-button>
          </div>
        </div>
      </el-card>
    </div>

    <div class="next">
      <el-button type="primary" icon="el-icon-arrow-left" @click="backPage">前へ戻る</el-button>
      <el-button type="primary" icon="el-icon-arrow-right" @click="nextPage" :disabled="!(check && signed)"
        >次へ進む</el-button
      >
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {setErrorLaravel} from '@/js/util/validate/validateFunction'
import ErrorMessage from '@/js/components/member/common/Atoms/ErrorMessage'
export default {
  data() {
    return {
      next: true,
      check: false,
      signed: false
    }
  },
  components: {
    ErrorMessage
  },
  mounted() {
    this.$emit('page', 'form-sigin')
    this.setSign()
    // Laravelのバリデーションエラーメッセージ
    if (this.getValidations.length) {
      this.getValidations.map((validate) => {
        setErrorLaravel(validate.key, validate.rule, validate.message, false)
      })
    }
  },
  beforeDestroy() {
    document.removeEventListener('touchstart', this.stopDefault)
    document.removeEventListener('touchmove', this.stopDefault)
    document.removeEventListener('touchend', this.stopDefault)
    document.removeEventListener('gesturestart', this.stopDefault)
    document.removeEventListener('gesturechange', this.stopDefault)
    document.removeEventListener('gestureend', this.stopDefault)
  },
  computed: {
    ...mapGetters({
      getHasPayment: 'status/getHasPayment',
      getValidations: 'sign/getValidations'
    })
  },
  methods: {
    nextPage() {
      // サイン送信 送信後次のページへ遷移可　サイン画像データは、storeに入る。
      axios.post('/api/store/contract/sign', {sign: this.convartBase64()}).then((res) => {
        this.setData(res.data)
        this.$emit('next')
        // this.$emit('transition',6);
      })
      // this.$emit('next')
    },
    backPage() {
      // this.$emit('transition',4);
      this.$emit('back')
    },
    setSign() {
      // 必要な変数を宣言しておく
      var canvas = this.$el.querySelector('#sign_canvas')
      var c = canvas.getContext('2d')
      var drawing = false
      var oldPos

      canvas.width = 600
      canvas.height = 250
      c.strokeStyle = '#000000'
      c.lineWidth = 3
      c.lineJoin = 'round'
      c.lineCap = 'round'

      var self = this

      // タップ開始時に、絵を描く準備をする
      canvas.addEventListener(
        'touchstart',
        (event) => {
          drawing = true
          oldPos = getPosT(event)
        },
        false
      )

      // タップ終了時に、絵を描く後処理を行う
      canvas.addEventListener(
        'touchend',
        () => {
          drawing = false
        },
        false
      )

      // gestureイベント（２本指以上で触ると発生するやつ）の
      // 終了時にも絵を描く後処理を行う
      canvas.addEventListener(
        'gestureend',
        () => {
          drawing = false
        },
        false
      )

      // 実際に絵を描く処理
      // 前回に保存した位置から現在の位置迄線を引く
      canvas.addEventListener(
        'touchmove',
        (event) => {
          var pos = getPosT(event)
          if (drawing) {
            c.beginPath()
            c.moveTo(oldPos.x, oldPos.y)
            c.lineTo(pos.x, pos.y)
            c.stroke()
            c.closePath()
            oldPos = pos

            this.signed = true
          }
        },
        false
      )

      // タップ開始時に、絵を描く準備をする
      canvas.addEventListener(
        'mousedown',
        (event) => {
          drawing = true
          oldPos = getPosT(event)
        },
        false
      )

      // タップ終了時に、絵を描く後処理を行う
      canvas.addEventListener(
        'mouseup',
        () => {
          drawing = false
        },
        false
      )

      // タップ終了時に、絵を描く後処理を行う
      canvas.addEventListener(
        'mouseout',
        () => {
          drawing = false
        },
        false
      )

      // 実際に絵を描く処理
      // 前回に保存した位置から現在の位置迄線を引く
      canvas.addEventListener(
        'mousemove',
        (event) => {
          var pos = getPosT(event)
          if (drawing) {
            c.beginPath()
            c.moveTo(oldPos.x, oldPos.y)
            c.lineTo(pos.x, pos.y)
            c.stroke()
            c.closePath()
            oldPos = pos

            this.signed = true
          }
        },
        false
      )

      function scrollX() {
        return $(window).scrollLeft()
      }
      function scrollY() {
        return $(window).scrollTop()
      }
      function getPosT(event) {
        var mouseX = 0
        var mouseY = 0
        if (_(event.touches).isUndefined()) {
          mouseX = event.clientX - $(canvas).offset().left + scrollX()
          mouseY = event.clientY - $(canvas).offset().top + scrollY()
        } else {
          mouseX = event.touches[0].clientX - $(canvas).offset().left + scrollX()
          mouseY = event.touches[0].clientY - $(canvas).offset().top + scrollY()
        }
        return {x: mouseX, y: mouseY}
      }

      document.addEventListener('touchstart', this.stopDefault, {passive: false})
      document.addEventListener('touchmove', this.stopDefault, {passive: false})
      document.addEventListener('touchend', this.stopDefault, {passive: false})
      document.addEventListener('gesturestart', this.stopDefault, {passive: false})
      document.addEventListener('gesturechange', this.stopDefault, {passive: false})
      document.addEventListener('gestureend', this.stopDefault, {passive: false})
    },
    eraser() {
      var canvas = this.$el.querySelector('#sign_canvas')
      var c = canvas.getContext('2d')
      c.clearRect(0, 0, canvas.width, canvas.height)
      c.beginPath()
      this.signed = false
    },
    stopDefault: function (event) {
      if (event.touches.length) {
        const $target = $(event.touches[0].target)
        if ($target.data('canvas') == 'canvasData') {
          event.preventDefault()
        }
      }
    },
    convartBase64() {
      const base64 = this.$el.querySelector('#sign_canvas').toDataURL('image/png').replace('data:image/png;base64,', '')
      return base64
    },
    /**
     * 規約PDFを表示する処理
     */
    displayTermsPdf() {
      window.open(`/pdf/terms/${this.getHasPayment}`)
    },

    ...mapActions({
      setData: 'sign/setData'
    })
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../sass/_variables.scss';
#sign_area {
  .error_message {
    padding-bottom: 0;
    margin-bottom: 0;
    font-size: 12px;
    color: red;
  }
}
.message_area {
  padding: 15px;
  border: 2px solid #eee;
  position: relative;
  // br.mg {
  //     display: none;
  // }
  // br.lg {
  //     display: none;
  // }
  // @include mq-down(lg) {
  //     br.lg {
  //         display: block;
  //     }
  // }
  // @include mq-down(mg) {
  //     br.mg {
  //         display: block;
  //     }
  // }
  &_btn {
    margin-bottom: 10px;
    // position: absolute;
    // top: 15px;
    // right: 15px;
  }
}
.checkarea {
  margin-top: 20px;
  text-align: center;
}
.box-card-wrapper {
  text-align: center;
}
.box-card {
  margin-top: 20px;
  display: inline-block;
}
.sign_space {
  border: 1px solid #ccc;
  height: 250px;
  width: 600px;
  canvas {
    height: 250px;
    width: 600px;
  }
}
.clear_btn {
  margin-top: 10px;
  text-align: right;
}
.next {
  margin-top: 40px;
  text-align: center;
  .el-button {
    border-radius: 0;
    padding-left: 30px;
    padding-right: 30px;
  }
}
</style>
